import { Box, Button, Flex, Grid, GridItem, Heading, Icon, IconButton, Spacer, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { useState } from "react";
import { FaArrowRight, FaFileContract } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ContractStateDto, useListContractsQuery } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../../common/errors/useApiError";
import { useSub } from "../../../common/subscription/useSub";
import { useSkeletons } from "../../../common/useSkeletons";
import { urls } from "../../../urls";
import { CreateContractModal } from "../../contracts/create/CreateContractModal";
import { Contract } from "./Contract";

export const LatestContracts = () => {
  const navigate = useNavigate();
  const authState = useLoggedInWithOrgContextState();
  const skeletons = useSkeletons();
  const sub = useSub();
  const { data, error } = useListContractsQuery({
    orgId: authState.selectedOrg.id,
    state: ContractStateDto.Published,
    limit: 5,
  });
  const [showCreateContractModal, setShowCreateContractModal] = useState(false);
  const displayer = useApiError();

  if (error) displayer.show(error);

  return (
    <Box
      flexDirection={"column"}
      alignItems="start"
      justifyContent={"start"}
      borderRadius={"10px"}
      boxShadow="0 3px 15px rgba(71, 85, 105, 0.16)"
      padding="20px"
      my="4"
      backgroundColor="smBackground"
    >
      {showCreateContractModal && <CreateContractModal onClose={() => setShowCreateContractModal(false)} />}
      <Grid
        gridTemplateColumns="50px 90px"
        gridTemplateAreas={`
                "icon title title"
                "unused1 events events"
                `}
      >
        <GridItem area="icon">
          <Box
            bg="smPrimarySoft"
            h="50px"
            w="50px"
            borderRadius={"50%"}
            display="flex"
            alignItems={"center"}
            justifyContent="center"
          >
            <Icon as={FaFileContract} w="18px" h="18px" color="smBackground" />
          </Box>
        </GridItem>
        <GridItem area="title" display={"flex"}>
          <Heading as="h2" fontSize="3xl" fontWeight={"semibold"} ml="10px" mt="7px">
            {t("Latest contracts")}
          </Heading>
        </GridItem>
        <GridItem area="events">
          {!data && skeletons.stackedLines(10)}
          {data?.contracts && (
            <>
              {data.contracts.map((contract) => {
                return <Contract key={contract.id} contract={contract} />;
              })}
              {data.contracts.length === 0 && (
                <Text fontSize={"md"} ml="10px" color="#5f6368" fontStyle={"italic"} mt="10px">
                  {t("You have no contracts right now!")}{" "}
                  {sub.canCreateContracts && (
                    <>
                      {t("Get started by")}
                      <Button
                        variant={"link"}
                        colorScheme="teal"
                        fontStyle={"italic"}
                        onClick={() => setShowCreateContractModal(true)}
                      >
                        {t("creating your first contract!")}
                      </Button>
                    </>
                  )}
                </Text>
              )}
            </>
          )}
          {data && (
            <Flex pt="4">
              <Spacer />
              <IconButton
                aria-label="go to contracts"
                icon={<Icon as={FaArrowRight} />}
                variant={"link"}
                colorScheme="cyan"
                float="right"
                onClick={() => {
                  navigate(`${urls.contracts.viewPublished}?status=Active,Awarded`);
                }}
              />
            </Flex>
          )}
        </GridItem>
      </Grid>
    </Box>
  );
};
